var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.31793 5.20984L8.17829 5.24451C7.95896 5.29874 7.81014 5.15104 7.04279 4.36328C6.66174 3.97229 6.18742 3.48568 5.74543 3.09729L5.72321 3.07544C5.49014 2.81391 5.22425 2.5742 5.01007 2.38123C4.84437 2.2325 4.70355 2.10415 4.61164 2.00134L4.57257 1.922C4.26887 2.23076 3.83294 2.68744 3.37458 3.16797C1.33903 5.30176 1.32245 5.30708 1.13263 5.26953L0.945621 5.20337L0.911685 5.06372C0.85811 4.84504 1.01674 4.68303 1.8675 3.86182C2.28934 3.45449 2.81377 2.9482 3.25421 2.45959C3.53431 2.20362 3.79588 1.91477 4.00617 1.68225C4.16133 1.51129 4.29471 1.36454 4.4007 1.26611L4.52326 1.19922L4.62067 1.19824L4.78864 1.20422L4.86212 1.33057C4.87781 1.35716 4.89133 1.39123 4.89582 1.43164L4.90705 1.42676L5.02765 1.53894C5.60618 2.07832 6.22235 2.67634 6.96588 3.4209C7.43334 3.88557 7.87867 4.35119 8.31623 4.80969L8.4173 4.91492L8.31793 5.20984Z",
    fill: "#18376D",
    stroke: "#18376D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.b2b63dc3abe39202aecd00abc41b7257.svg";
export { ForwardRef as ReactComponent };